module.exports = __webpack_public_path__ + "img/home_btn_welfare@2x.feba332d.png";